import { Button, Modal } from '@st/theme'
import { FilesInputConfig } from '@st/ui-config'
import { useState } from 'react'
import { match } from '@st/pattern'
import { ClientUploadDocumentsCard } from '~/features/st-questionnaire/client-upload-documents-card'

export function WizardFilesInput({ documentType }: FilesInputConfig) {
  const [visible, setVisible] = useState(false)
  return (
    <div className="flex flex-col justify-center">
      <Button size="l" onClick={() => setVisible(true)}>
        Upload documents
      </Button>

      {match(visible)
        .with(true, () => (
          <Modal isOpen={true}>
            <ClientUploadDocumentsCard
              documentType={documentType ?? undefined}
              variant="dialog"
              onClose={() => setVisible(false)}
            />
          </Modal>
        ))
        .otherwise(() => null)}
    </div>
  )
}
